var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"inner"},[_c('h1',[_vm._v("エラーが発生しました")]),_c('p',[_vm._v(_vm._s(_vm.errorMessage))])])])}
var staticRenderFns = []

export { render, staticRenderFns }